import { create } from "zustand";
import { persist } from "zustand/middleware";
import { getThemeMode, type ThemeMode } from "@/themes/theme-mode.ts";

export interface ThemeStore {
  colorMode: ThemeMode;
  setColorMode: (colorMode: ThemeMode) => void;
  theme: string;
  setTheme: (newTheme: string) => void;
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      colorMode: "light",
      setColorMode: (colorMode) => set({ colorMode }),
      theme: "default",
      setTheme: (newTheme: string) =>
        set(() => ({
          theme: newTheme || "default",
        })),
    }),
    {
      name: "theme",
      version: 1,
      migrate: (state) => ({
        theme: (state as { theme?: string } | null)?.theme || "default",
        colorMode: getThemeMode(state),
      }),
      partialize: ({ theme, colorMode }) => ({ theme, colorMode }),
    }
  )
);
